import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const localNationalClimateReferencesRoutes: Routes = [
  {
    title: 'pagesTitles.localNationalClimateReferences',
    path: APP_ROUTES.LOCAL_NATIONAL_CLIMATE_REFERENCES,
    canActivate: [permissionGuard(APP_PERMISSIONS.LocalNationalClimateReferenceRead)],
    loadComponent: () =>
      import('./pages/local-national-climate-references-list').then(
        (m) => m.LocalNationalClimateReferencesList
      ),
  },
];
